/* eslint-disable no-empty */
import FavoritesServer from '../../server/favorites';
import { addLoading, removeLoading } from './loading';

export const setFavorites = items => ({
  type: 'PRODUCTS_FAVORITES_SET',
  items,
});

export const getProductsFavorites = (productId, code) => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const { contracts } = getState();
    const clientId = contracts.selected && contracts.selected.client.id;
    const productsFavorites = await FavoritesServer.getFavorites(clientId, productId, code);

    dispatch(setFavorites(productsFavorites));
  } finally {
    dispatch(removeLoading());
  }
};

export const setProductsFavorites = (productId, productCode, productClientCode, quantity) => async (
  dispatch,
  getState,
) => {
  dispatch(addLoading());
  try {
    const { contracts } = getState();
    const clientId = contracts.selected && contracts.selected.client.id;
    await FavoritesServer.addFavorites(
      clientId,
      productId,
      productCode,
      productClientCode,
      quantity,
    );
    await dispatch(getProductsFavorites());
  } finally {
    dispatch(removeLoading());
  }
};

export const favoritesRemoveItem = (productFavoriteId, clientId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FavoritesServer.deleteFavorites(productFavoriteId, clientId);
    await dispatch(getProductsFavorites());
  } finally {
    dispatch(removeLoading());
  }
};

export const updateFavorite = (favoriteId, quantity) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FavoritesServer.updateFavorite(favoriteId, quantity);
    await dispatch(getProductsFavorites());
  } finally {
    dispatch(removeLoading());
  }
};
